
import { of as observableOf, Observable } from 'rxjs';
import { Injectable } from '@angular/core';

import { HisBackendService } from 'hisng';

import { ResearchInfrastructure } from '../model/research-infrastructure';

@Injectable()
export class ResearchInfrastructureService {

    constructor( private backendService: HisBackendService ) { }

    getResearchInfrastructureById( id: number ): Observable<ResearchInfrastructure> {
        return this.backendService.getData( `api/v1/fs/res/researchInfrastructure/${id}` );
    }

    getResearchInfrastructureWithDetailsById( id: number ): Observable<ResearchInfrastructure> {
        return this.backendService.getData( `api/v1/fs/res/researchInfrastructure/${id}/details` );
    }

    getResearchInfrastructuresByIds(ids: number[]): Observable<ResearchInfrastructure[]> {
        let idsStr = '';
        if ( ids.length > 0 ) {
            for ( let id of ids ) {
                idsStr += id + ',';
            }
            idsStr = idsStr.substring( 0, idsStr.length - 1 );
        }
        return this.backendService.getData( `api/v1/fs/res/researchInfrastructures/${idsStr}` );
    }

    saveResearchInfrastructure( ri: ResearchInfrastructure ): Observable<ResearchInfrastructure> {
        let savedRI: Observable<ResearchInfrastructure>;
        if ( ri.id == null ) {
            savedRI = this.backendService.postData( 'api/v1/fs/res/researchInfrastructure', ri );
        } else {
            savedRI = this.backendService.putData( `api/v1/fs/res/researchInfrastructure/${ri.id}`, ri );
        }
        return savedRI;
    }

    /**
     * Delete research infrastructure with the given id.
     *
     * @param researchInfrastructureId
     * @return Observable.of( 0: failure, 1: success )
     */
    deleteResearchInfrastructure( researchInfrastructureId: number ): Observable<number> {
        return this.backendService.delete( `api/v1/fs/res/researchInfrastructure/${researchInfrastructureId}` );
    }

    getNewResearchInfrastructure(): Observable<ResearchInfrastructure> {
        return observableOf( new ResearchInfrastructure() );
    }

    canViewResearchInfrastructure( id: number ): Observable<boolean> {
        return this.backendService.postData(
            `api/v1/fs/res/hasRightsOnObject/ResearchInfrastructure/${id}/true`,
            [
                'RIGHT_FS_RES_RESEARCHINFRASTRUCTURE_VIEW_RESEARCH_INFRASTRUCTURE',
                'RIGHT_FS_RES_RESEARCHINFRASTRUCTURE_VIEW_RESEARCH_INFRASTRUCTURE_VISIBLE',
            ] );
    }
    canEditResearchInfrastructure( id: number ): Observable<boolean> {
        return this.backendService.postData(
            `api/v1/fs/res/hasRightsOnObject/ResearchInfrastructure/${id}/true`,
            [
                'RIGHT_FS_RES_RESEARCHINFRASTRUCTURE_EDIT_RESEARCH_INFRASTRUCTURE'
            ] );
    }
}
